module.exports = __webpack_public_path__ + "static/media/PortfolioSPA.7f6dd0cf.png";